import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Person } from 'src/app/modules/entities/person';
import { City } from 'src/app/modules/entities/city';
import { Locality } from 'src/app/modules/entities/locality';
import { User } from 'src/app/modules/entities/user';
import { CityService } from 'src/app/modules/services/city.service';
import { LocalityService } from 'src/app/modules/services/locality.service';
import { PersonService } from 'src/app/modules/services/person.service';
import { ServicePlaceService } from 'src/app/modules/services/service-place.service';
import { ServicePlace } from 'src/app/modules/entities/service-place';
import { ServiceCategoryService } from 'src/app/modules/services/service.service';
import { CategoryService } from 'src/app/modules/entities/service';
import { url } from 'src/app/modules/util/constants';

interface Gender {
  name: string;
  value: number;
}

@Component({
  selector: 'app-person-register',
  templateUrl: './person-register.component.html',
  styleUrls: ['./person-register.component.css']
})

export class PersonRegisterComponent implements OnInit {

  constructor(private router: Router, private fb: FormBuilder, private cityService: CityService, 
    private localityService: LocalityService, private personService: PersonService, private messageService: MessageService,
    private servicePlaceService: ServicePlaceService, private serviceCategoryService: ServiceCategoryService) {
    const navigation = this.router.getCurrentNavigation();
    this.user = navigation?.extras.state?.['user'];
    this.personForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(100), Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚÜüÑñ\\s]+')]],
      age: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2), Validators.pattern('[0-9]+'), Validators.min(18)]],
      locality: [{value: '', disabled: true}, [Validators.required]],
      city: ['', [Validators.required]],
      servicePlaces: ['', [Validators.required]],
      pricePerHour: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(6), Validators.pattern('[0-9]+'), Validators.min(10000), 
        Validators.max(999999)]],
      schedule: ['', [Validators.required, Validators.maxLength(100)]],
      description: ['', [Validators.required, Validators.minLength(200), Validators.maxLength(2000)]],
      gender: ['', [Validators.required]]
    });
  }

  personForm: FormGroup;
  steps: MenuItem[] | undefined;
  cities: City[] | undefined;
  localities: Locality[] | undefined;
  servicePlaces: ServicePlace[] = [];
  services: CategoryService[] = [];
  serviceOptionsByCategory: { [key: string]: CategoryService[] } = {};
  categories: string[] = [];
  genders: Gender[] | undefined;
  user: User;
  loading: boolean = false;

  ngOnInit() {
    if (this.user === undefined)
      this.router.navigate([url['registro-1']]);
    this.steps = [
        {
            label: 'Contacto',
            routerLink: '/' + url['registro-1']
        },
        {
            label: 'Descripción',
            routerLink: '/' + url['registro-2']
        },
        {
            label: 'Multimedia',
            routerLink: '/' + url['carga-imagenes']
        }
    ];
    this.getVisibleCities();
    this.getServicePlacesAsOptions();
    this.getServices();
    this.genders = [
      {
        name: 'Mujer',
        value: 1
      }
    ]
    this.personForm.get('gender')!.setValue(this.genders[0]);
  }

  savePerson() {
    this.loading = true;
    this.services = [];
    for (let category of this.categories) {
      this.services.push(this.personForm.value['service-' + this.cleanUrlId(category)]);
    }
    let person: Person = {
      idperson: 0,
      name: this.cleanName(this.personForm.value['name']),
      age: this.personForm.value['age'],
      locality: this.personForm.value['locality'],
      city: this.personForm.value['city'],
      schedule: this.personForm.value['schedule'],
      description: this.personForm.value['description'],
      gender: this.personForm.value['gender'],
      url_id: this.cleanUrlId(this.personForm.value['name']) + this.user.userName,
      visible: 0,
      verified: 0,
      lastUpdated: new Date(),
      user: this.user,
      pricePerHour: this.personForm.value['pricePerHour'],
      services: this.services,
      servicePlaces: this.personForm.value['servicePlaces'],
      subscriptionDetails: undefined,
      mediaContent: undefined,
      interactions: undefined
    }
    this.personService.saveUserAndPerson(person).subscribe(resultResponse => {
      if (resultResponse.status === 'success') {
        let navigationExtra: NavigationExtras = {
          state: { message: "La información se ha guardado correctamente.", person: resultResponse.data }
        }
        this.router.navigate([url['carga-imagenes']], navigationExtra);
        this.loading = false;
      } else {
        this.messageService.add({
          severity: resultResponse.status,
          detail: 'Error guardando la información.'
        });
      }
    });
  }

  getVisibleCities() {
    this.cityService.getCities().subscribe(response => {
      if (response.status === 'success') {
        this.cities = response.data;//.filter(city => city.visible === 1);
      }
    });
  }

  getServicePlacesAsOptions() {
    this.servicePlaceService.getServicePlaces().subscribe(response => {
      if (response.status === 'success') {
        this.servicePlaces = response.data;
      }
    });
  }

  getServices() {
    this.serviceCategoryService.getServices().subscribe(response => {
      if (response.status === 'success') {
        let services = response.data;
        for (let service of services) {
          if (this.serviceOptionsByCategory[service.category] === undefined) {
            this.serviceOptionsByCategory[service.category] = []
            this.categories.push(service.category);
          }
          this.serviceOptionsByCategory[service.category].push(service);
        }
        for (let category of this.categories) {
          this.personForm.addControl('service-' + this.cleanUrlId(category), this.fb.control('', Validators.required));
        }
      }
    });
  }

  onCitySelection(event: DropdownChangeEvent) {
    if (event.value.id) {
      this.localityService.getVisibleLocalitiesByCity(this.personForm.get('city')?.value.id).subscribe(response => {
        if (response.status === 'success') {
          this.localities = response.data;
          this.personForm.get('locality')?.enable();
        }
      });
    }
  }

  cleanName(name: string): string {
    name = name.replace(/\s+/g, ' ');
    name = name.replace(/[^A-Za-zÑñáéíóúÁÉÍÓÚÜü\s]/g, '');
    name = name.trim();
    name = name.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase());
    return name;
  }

  cleanUrlId(name: string): string {
    name = name.trim();
    name = name.replace(/\s+/g, '-');
    name = name.replace(/-+/g, '-');
    name = name.replaceAll('Á', 'A');
    name = name.replaceAll('á', 'a');
    name = name.replaceAll('É', 'E');
    name = name.replaceAll('é', 'e');
    name = name.replaceAll('Í', 'I');
    name = name.replaceAll('í', 'i');
    name = name.replaceAll('Ó', 'o');
    name = name.replaceAll('ó', 'o');
    name = name.replaceAll('Ú', 'u');
    name = name.replaceAll('ú', 'u');
    name = name.replaceAll('Ü', 'u');
    name = name.replaceAll('ü', 'u');
    name = name.replaceAll('Ñ', 'N');
    name = name.replaceAll('ñ', 'n');
    name = name.replace(/[^A-Za-z-]/g, '');
    return name.toLowerCase();
  }

}
